<template>
  <footer
    id="footer"
    class="container"
  >
    <div class="row">
      <div class="col-sm footer-left_col">
        <div class="footer-copyright">
          &copy; 2008-{{ getCurrentYear }}  ФГБОУ ДПО «Институт развития профессионального образования»
        </div>

      </div>
      <div class="col-sm col-md-7 footer-right_col">
        <div class="footer-links">
          <ul class="nav">



          </ul>
        </div>
        <div class="footer-social">
          <ul class="nav">




          </ul>
        </div>
      </div>
    </div>

  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    getCurrentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped lang="scss">
#footer {
  padding: 30px 15px;
}
.footer-copyright {
  font-size: 11px;
  line-height: 13px;
  color: #9c9c9c;
  margin-bottom: 15px;
  padding-top: 0.5rem;
}

.footer-links {
  .nav {
    justify-content: flex-end;
  }
  .nav-item {
    &:last-child {
      .nav-link {
        padding-right: 0;
      }
    }
  }
  .nav-link {
    padding-top: 0;
    padding: 0.5rem 0.3rem;
  }

  a {
    color: #9c9c9c;
    font-size: 11px;
    line-height: 13px;
  }
}

.footer-social {
  .nav {
    justify-content: flex-end;
    .nav-item {
      &:last-child {
        .nav-link {
          padding-right: 0;
        }
      }
    }
  }

  .nav-link {
    padding: 0.5rem 0.5rem;
  }

  a svg:hover #vk {
    fill: #5352d2;
  }
}

.footer-hashtags {
  a {
    font-size: 11px;
    line-height: 13px;
    color: #6d9ae8;
    margin-right: 10px;
  }
}

svg:hover path {
  fill: #5352d2;
}

@include media-breakpoint-down(sm) {
  #footer {
    padding: 30px 30px 20px 32px;
  }
  .footer-right_col {
    order: -1;
    .nav {
      justify-content: flex-start;
    }

    .nav-link {
      padding-left: 5px;
    }
  }

  .footer-copyright {
    margin-bottom: 0;
  }

  .footer-social {
    margin-top: 7px;
  }

  .footer-left_col {
    padding-left: 20px;
    display: -ms-inline-grid;
    display: inline-grid;

    .footer-hashtags {
      order: -1;
    }
  }
}
</style>
